<template>
  <div class="quality-inspection-pc">
    <a-tabs type="card" v-model:activeKey="tabActivekey">
      <!-- <a-tab-pane key="materialrequistion" tab="领料单">
        <materialRequistion></materialRequistion>
      </a-tab-pane> -->

      <a-tab-pane key="instruction" tab="生产指令单">
        <instruction></instruction>
      </a-tab-pane>

      <a-tab-pane key="tasks" tab="生产任务表">
        <task></task>
      </a-tab-pane>

      <a-tab-pane key="inventory" tab="半成品库存">
        <inventorysf></inventorysf>
      </a-tab-pane>
      <a-tab-pane key="summaryOfpassRate" tab="合格率汇总">
        <pass-rate :activeKey="tabActivekey"></pass-rate>
      </a-tab-pane>
      <a-tab-pane tab="不合格统计" key="summaryOfunqualifiedStatistics">
        <a-tabs type="card" v-model:activeKey="subUnqualifiedKey">
          <a-tab-pane tab="不合格率汇总" key="summaryOfunqualified">
            <unqualified-statistics> </unqualified-statistics>
          </a-tab-pane>

          <a-tab-pane tab="问题明细" key="summaryOfunqualifiedDetails">
            <unqualified-details> </unqualified-details>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, ref, provide } from "vue";

import unqualifiedStatistics from "@/views/productDaily/components/quality/unqualified/index.vue";
import unqualifiedDetails from "@/views/productDaily/components/quality/unqualified/details.vue";
import passRate from "@/views/productDaily/components/quality/PassRate/index.vue";
import inventorysf from "@/views/productDaily/components/product/components/inventorySF/index.vue";
import task from "@/views/productDaily/components/product/organizingTasks/index.vue";
import instruction from "@/views/productDaily/components/instruction/index.vue";
import materialRequistion from "@/views/productionInstruction/materialRequisition/index.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    passRate,
    unqualifiedDetails,
    unqualifiedStatistics,
    inventorysf,
    instruction,
    task,
    materialRequistion,
  },
  setup() {
    const tabActivekey = ref("instruction");

    provide("tabActivekey", tabActivekey);

    const subUnqualifiedKey = ref("null");

    provide("subUnqualifiedKey", subUnqualifiedKey);

    const route = useRoute();

    const produceOrTpc = route.meta.produceOrTpc;

    provide('produceOrTpc', produceOrTpc);

    return {
      tabActivekey,
      subUnqualifiedKey,
    };
  },
});
</script>

<style lang="less" scoped>
.quality-inspection-pc {
  width: 100%;
  height: calc(100vh - 110px);
  box-shadow: 0 0 5px 0 #ccc;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
}
</style>
